export default __webpack_public_path__ + "static/media/sarah-2.c7c82080.png";